import { ImgHTMLAttributes } from "react"
import { styled, callCSSFn, StylePropsWithCSS, WithCSS } from "../styles"

type Props = ImgHTMLAttributes<HTMLImageElement> & WithCSS & { src?: string }
export const Img = styled.img<Props>((props: StylePropsWithCSS) => ({
  ...callCSSFn(props),
}))
